<script>
/**
 * @author Evgeny Shevtsov <info@sitespring.ru>
 * @homepage https://sitespring.ru
 * @licence Proprietary, Commercial
 */
import ChartBar from "@/components/ChartBar";
import ReportModel from "@/views/report/payment/ReportModel";
import {map} from "lodash";
import Formatter from "@/utils/Formatter";
import {Doughnut} from "vue-chartjs"

export default {
    name: 'DataChart',
    components: {ChartBar, Doughnut},
    props: {
        model: {
            type: ReportModel
        }
    },
    data() {
        return {
            chartData: {},
            options: {
                tooltips: {
                    callbacks: {
                        label({datasetIndex, index}, {labels, datasets}) {
                            const {data} = datasets[datasetIndex]
                            return `${labels[index]} ${Formatter.asCurrency(data[index])}`;
                        }
                    }
                }
            }
        }
    },
    methods: {
        calculateChartData(data) {
            if (!data || data.length === 0) {
                this.chartData = {labels: [], datasets: []};
                return
            }

            const datasets = [{
                label: 'My First Dataset',
                data: map(data, ({total}) => parseFloat(total)),
                backgroundColor: map(data, () => '#' + this.createRandomColor()),
            }]
            let labels = map(data, ({typeText}) => typeText);
            this.chartData = {labels, datasets};
        },
        createRandomColor() {
            return Math.floor(Math.random() * 16777215).toString(16);
        },
        onDataFetch({data}) {
            console.log('On data fetched', data)
            this.calculateChartData(data);
            this.$refs.chartCmp.renderChart(this.chartData, this.options)
        }
    },
    computed: {
        isEmpty: (vm) => vm.chartData.datasets && vm.chartData.datasets.length === 0
    },
    created() {
        this.model.on('fetch', this.onDataFetch);
    }
}
</script>

<template>
    <div class="chart">
        <p v-if="isEmpty">Нет данных для данного набора фильтров</p>
        <Doughnut ref="chartCmp"/>
    </div>
</template>
<style scoped lang="scss">
.chart {
    display: block;
    width: 400px;
}
</style>
